import script from "./newCard.vue?vue&type=script&setup=true&lang=js"
export * from "./newCard.vue?vue&type=script&setup=true&lang=js"

import "./newCard.vue?vue&type=style&index=0&id=0341947d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0341947d"]])

export default __exports__